import { theme, darkTheme } from './theme/themeVariables';

const config = {
  darkMode: true,
  topMenu: false,
  rtl: false,
  theme,
  darkTheme,
};

export default config;
